import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class EarthPressuresDataModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (EarthPressuresDataModel._instance == null) EarthPressuresDataModel._instance = new EarthPressuresDataModel(authManager);
        return EarthPressuresDataModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'earth-pressures/earth-pressures-data');

        this.entityName = 'earth-pressures.EarthPressuresData';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Primary Stress Result';
        this.setLabel = 'Primary Stress Results';

        this.browser = {
            name: 'default-earth-pressures-earthpressuresdata-browser',
            moduleName: 'default-earth-pressures-earthpressuresdata-browser',
            moduleTitle: 'Primary Stress Results',
            moduleStateSlotName: 'default-earth-pressures-earthpressuresdata-browser',
        };

        this.editor = {
            name: 'default-earth-pressures-earthpressuresdata-editor',
            moduleName: 'default-earth-pressures-earthpressuresdata-editor',
            moduleTitle: 'Primary Stress Result',
            moduleStateSlotName: 'default-earth-pressures-earthpressuresdata-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'calculationId',
                type: 'EarthPressuresCalculation',
                persistent: true,
                label: 'Calculation',
            },
            {
                name: 'earthPressuresModelIntervalId',
                type: 'EarthPressuresModelInterval',
                persistent: true,
            },
            {
                name: 'modelIntervalId',
                type: 'ModelInterval',
                persistent: false,
                label: 'Model Interval',
                description: 'reference to particular ps model interval',
                readOnly: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: false,
                label: 'Model Section',
                description: 'only for info (check)',
                readOnly: true,
            },
            {
                name: 'isModelSectionMassTopInterval',
                type: 'bool',
                persistent: false,
                label: 'Is Model Section Mass Top Interval',
                description: 'is interval the top soil mass or rock mass of the model ?',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationTop',
                type: 'float',
                persistent: false,
                unit: 'm',
                label: 'Elevation Top',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'elevationBottom',
                type: 'float',
                persistent: false,
                unit: 'm',
                label: 'Elevation Bottom',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
            },
            {
                name: 'thickness',
                type: 'float',
                persistent: false,
                unit: 'm',
                label: 'Thickness',
                description: 'HD: pro zobrazeni dat, nerozmysleno …',
                readOnly: true,
            },
            {
                name: 'isModelSectionTopInterval',
                type: 'bool',
                persistent: false,
                label: 'Is Model Section Top Interval',
                readOnly: true,
            },
            {
                name: 'isModelSectionBottomInterval',
                type: 'bool',
                persistent: false,
                label: 'Is Model Section Bottom Interval',
                readOnly: true,
            },
            {
                name: 'waterBodyId',
                type: 'WaterBody',
                persistent: false,
                label: 'Water Body',
                description: 'reference to particular water body',
                readOnly: true,
            },
            {
                name: 'waterBodyTypeId',
                type: 'WaterBodyType',
                persistent: false,
                label: 'Water Body Type',
                description: 'reference to particular water body type',
                readOnly: true,
            },
            {
                name: 'waterUnitWeightGamaW',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Water Unit Weight Gama W',
                readOnly: true,
            },
            {
                name: 'coefficientOfSidePressureKWater',
                type: 'float',
                persistent: false,
                unit: '1',
                label: 'Coefficient Of Side Pressure K Water',
                readOnly: true,
            },
            {
                name: 'isWithinWaterBody',
                type: 'bool',
                persistent: false,
                label: 'Is Within Water Body',
                readOnly: true,
            },
            {
                name: 'isWithinWaterBodyAndHasBuoyancyEffect',
                type: 'bool',
                persistent: false,
                label: 'Is Within Water Body And Has Buoyancy Effect',
                readOnly: true,
            },
            {
                name: 'waterIntervalPressureUzTop',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                readOnly: true,
            },
            {
                name: 'waterIntervalIncreaseUzInc',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                readOnly: true,
            },
            {
                name: 'waterIntervalPressureUzBottom',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                readOnly: true,
            },
            {
                name: 'geoTypeId',
                type: 'GeoType',
                persistent: false,
                readOnly: true,
            },
            {
                name: 'k0CalcMethodId',
                type: 'K0CalculationMethod',
                persistent: false,
                label: 'K 0 Calc Method',
                description: '(coefficient of lateral earth pressure at rest)',
                readOnly: true,
            },
            {
                name: 'coefficientOfLateralEarthPressureAtRestK0',
                type: 'float',
                persistent: false,
                unit: '1',
                label: 'Coefficient Of Lateral Earth Pressure At Rest K 0',
                readOnly: true,
            },
            {
                name: 'loadId',
                type: 'GeoLoad',
                persistent: false,
                label: 'Load',
                readOnly: true,
            },
            {
                name: 'continuousUniformVerticalLoadP',
                type: 'float',
                persistent: false,
                unit: 'kPa',
                label: 'Continuous Uniform Vertical Load P',
                description: 'at top of interval',
                readOnly: true,
            },
            {
                name: 'soilUnitWeightGama',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                readOnly: true,
            },
            {
                name: 'sigmaZGeosTotTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Geos Tot Top',
                description: 'vertical GEOStatic total stress at top of interval; if soil top interval =0 else =sigmaZGeosBottom from previous interval',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZGeosTotIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Geos Tot Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZGeosTotBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZLoadTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Load Top',
                description: 'vertical stress at top of interval from all loads >= level of interval,top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZLoadIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Load Increment',
                description: 'zatím vždy 0',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZLoadBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Load Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZTotTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Tot Top',
                description: 'vertical total stress at top of interval',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZTotIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Tot Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZTotBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Tot Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZGeosEffTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Geos Eff Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZGeosEffIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Geos Eff Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZGeosEffBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Geos Eff Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZEffTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Eff Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZEffIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Eff Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaZEffBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma Z Eff Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXLoadTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Load Top',
                description: '    horizontal load stress at top of interval;\n    =sigmaZLoadTop*coefficientOfLateralEarthPressureAtRestK0calculated01',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXLoadIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Load Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXLoadBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Load Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterIntervalPressureUxTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterIntervalPressureUxIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterIntervalPressureUxBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXGeosEffTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Geos Eff Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXGeosEffIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Geos Eff Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXGeosEffBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Geos Eff Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXGeosTotTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Geos Tot Top',
                description: 'horizontal GEOS total stress at top of interval; =sigmaXGeosEffTop+waterIntervalPressureUxTop',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXGeosTotIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Geos Tot Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXGeosTotBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Geos Tot Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXEffTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Eff Top',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXEffIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Eff Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXEffBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Eff Bottom',
                description: 'horizontal effective stress in soil at bottom of interval',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXTotTop',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Tot Top',
                description: '    horizontal total stress at top of interval;\n    =sigmaXGeosTotTop+sigmaXLoadTop',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXTotIncrement',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Tot Increment',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'sigmaXTotBottom',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Sigma X Tot Bottom',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
